export const WORKSPACE_MIN_ZOOM = 0.2;
export const WORKSPACE_MAX_ZOOM = 2.5;
export const WORKSPACE_FIT_VIEW_PADDING = 0.2;
